import transformProps from '@didi/webx-ui-utils/src/transform-props'
import config from '../../../views/cz/config'

const props = {
  info: {
    type: Object,
    value: () => config,
  },
  pageConfig: {
    type: Object,
    value: () => ({
      index: {
        button: {
          text: '立即领取',
          gotoText: '去使用',
        },
        showStation: true,
        link: 'https://didi.cn/RXnew9z',
        title: '滴滴有车 | 车主新选择',
        style: {
          backgroundImage:
            'https://ut-static.udache.com/webx/ut/tjkNdWS4tHLevW1M1lbKa.png',
          backgroundColor: '#FFCB8D',
        },
      },
      showTabOrder: 'gasFirst',
      redPacket: {
        _closeTitle: '滴滴有车专享券包',
        subTitle: '内含加油、代驾、充电、车品等券',
      },
      textRoll: {
        text: '滴滴车主支持导航、违章查询、限行红包、车品保养等服务',
      },
      conversion: {
        isShow: true,
        leftImg:
          'https://ut-static.udache.com/webx/ut/IVM7MzZwpMHIjV44LKFuu.png',
        leftLink: 'https://didi.cn/n7ojnaL',
        rightImg:
          'https://ut-static.udache.com/webx/ut/3uPrG7NqKq54KT5c10VBj.png',
        rightLink: 'https://didi.cn/vOJwaDr',
      },
      rule: {
        link: '',
        style: {
          top: 80,
          color: '#FFFFFF',
          backgroundColor: 'rgba(0,0,0,.3)',
        },
      },
      popup: {
        button: {
          text: '去使用',
        },
      },
      imageList: [
        {
          image:
            'https://ut-static.udache.com/webx/ut/9OGemiPgAeVgZNnShhN5X.png',
          style: {
            marginTop: 40,
            width: 700,
          },
        },
        {
          image:
            'https://ut-static.udache.com/webx/ut/WSSbs9Ywvh_eFodbyHoNE.png',
          style: {
            marginTop: 40,
            width: 700,
          },
        },
      ],
    }),
  },
}

const mockIndex = {
  errno: 0,
  errmsg: '',
  traceid: '123',
  data: {
    group: {
      id: '1e32e345456454',
      status: 1,
    },
    rewards: [
      {
        type: 'coupon',
        coupon: {
          usage_limit: '满￥200可用',
          valid_period: '有效期截止2021.12.24',
          name: '加油福利券',
          type: 1,
          max_benefit_capacity: {
            value: 30,
            unit: '元',
          },
        },
      },
    ],
    activity_info: {
      id: 1,
      rewards: [
        {
          type: 'coupon',
          coupon: {
            name: '加油福利券',
            usage_limit: '',
            valid_period: '',
            type: 1,
            max_benefit_capacity: {
              value: 20,
              unit: '元',
            },
          },
        },
      ],
    },
  },
}

const { propsForView, propsForModel, propsForStory } = transformProps(props)

export { props, propsForView, propsForModel, propsForStory, mockIndex }
